module.exports = __webpack_public_path__ + "static/img/xydjpj.88558df6.png";